const FeedbackModule = () => {
  const modalEl = document.querySelector('[data-widget="qualtrics-modal"]');
  //check if page contains feedback module
  if (modalEl) {
    const openerBtn = modalEl.querySelector('[data-label="feedback"]');
    const closerBtn = modalEl.querySelector('button.btn');

    const openModal = () => {
      modalEl.classList.add('open');
    };

    const exitModal = () => {
      modalEl.classList.remove('open');
    };

    openerBtn.addEventListener('click', openModal);
    closerBtn.addEventListener('click', exitModal);
  }
};

export default FeedbackModule;
